import { render, staticRenderFns } from "./teacherroutine.vue?vue&type=template&id=e0b05838&"
import script from "./teacherroutine.vue?vue&type=script&lang=js&"
export * from "./teacherroutine.vue?vue&type=script&lang=js&"
import style0 from "./teacherroutine.vue?vue&type=style&index=0&id=e0b05838&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports